var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpMd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.0071C19.0022 13.7445 18.9013 13.4915 18.7188 13.3026L12.7082 7.29324C12.5204 7.10548 12.2656 7 12 7C11.7344 7 11.4796 7.10548 11.2918 7.29324L5.28121 13.3026C5.09873 13.4915 4.99776 13.7445 5.00004 14.0071C5.00232 14.2697 5.10767 14.521 5.29341 14.7066C5.47914 14.8923 5.7304 14.9977 5.99305 15C6.25571 15.0022 6.50876 14.9013 6.69769 14.7188L12 9.41756L13.0018 10.4191L17.3023 14.7188C17.4912 14.9013 17.7443 15.0022 18.0069 15C18.2696 14.9977 18.5209 14.8923 18.7066 14.7066C18.8923 14.5209 18.9977 14.2697 19 14.0071Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpMd);
export default __webpack_public_path__ + "static/media/up-md.4598e903a3b8730862324f19b3306072.svg";
export { ForwardRef as ReactComponent };